import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { actions } from '../../../../context';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faClock,
    faLongArrowAltDown,
    faLongArrowAltUp,
} from '@fortawesome/free-solid-svg-icons';

const CommsFilterToggle = () => {
    const dispatch = useDispatch();
    const [sortCommsNewFirst, setSortCommsNewFirst] = useState(false);
    const toggleSortingCommunications = () => {
        var newSortingValue = !sortCommsNewFirst;
        setSortCommsNewFirst(newSortingValue);
        // TODO: this does no client side filtering it sends an HTTP request
        dispatch(actions.communication.fetchCommunicationActivity(newSortingValue));
    };
    const title = `Sort by ${sortCommsNewFirst ? 'most' : 'least'} recently active`;
    const arrow = sortCommsNewFirst ? faLongArrowAltDown : faLongArrowAltUp;
    return (
        <div className="m-2 py-1 text-nowrap" title={title} onClick={toggleSortingCommunications}>
            <span className="hoverable underline-on-hover">
                {sortCommsNewFirst ? `Newest ` : `Oldest `} active&emsp;
                <FontAwesomeIcon icon={faClock} size="lg" />
                &nbsp;
                <FontAwesomeIcon icon={arrow} size="lg" />
            </span>
        </div>
    );
};

export default CommsFilterToggle;
